import { Component, Inject, OnInit } from '@angular/core';
import {
    MeasurementToolsDetailsModel,
    MeasurementToolsInstanceToken,
    MeasurementToolsInterface,
} from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-measurement-tools',
    templateUrl: './measurement-tools.component.html',
    styleUrls: ['./measurement-tools.component.scss'],
    standalone: false,
})
export class MeasurementToolsComponent implements OnInit {
    public measurementTools: Array<MeasurementToolsDetailsModel & { isCollapsed: boolean }>;
    public isMeasurementToolsEmpty = false;
    public fieldName = '';
    public reverse = false;
    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
    public constructor(
        @Inject(MeasurementToolsInstanceToken) private readonly measurementToolsService: MeasurementToolsInterface,
        public readonly modalInstance: BsModalRef,
    ) {}

    public ngOnInit(): void {
        const tools = this.measurementToolsService.getMeasurementToolsDetailsList();
        this.measurementTools = tools.map((tool) => ({
            ...tool,
            isCollapsed: true,
            isToolInvalid: tool.isToolInvalid.bind(tool),
        }));

        this.isMeasurementToolsEmpty =
            this.measurementTools.length === 1 && this.measurementTools[0].message.length > 0;
    }
    public setOrderBy(field: string): void {
        if (this.fieldName === field) {
            this.reverse = !this.reverse;
        } else {
            this.fieldName = field;
        }
    }

    public toggleCollapse(tool: MeasurementToolsDetailsModel & { isCollapsed: boolean }): void {
        tool.isCollapsed = !tool.isCollapsed;
    }
}
